<div class="container-fluid">
  <div class="row">
    <h3 class="page-header">{{pageHeader}}</h3>
  </div>
  <div id="grid">
    <div class="row">
      <div class="col-xs-12">
        <aims-common-table
            id="observations-table"
            [dataSource]="observations | async"
            [header]="tableHeader"
            [permissions]="tablePermissions"
            [exportFunction]="getForExcel"
            pageSize="5"
            [stickyHeader]="true">

            <ng-template aimsCommonTableDynamicToolbar>
              <aims-common-button aria-label="Print Report"
                *ngIf="isCar && isOpen && !(observations === undefined || observations == null)"
                [routerLink]="printReportName" >
                    <mat-icon>print</mat-icon>Print Report
              </aims-common-button>
              <aims-common-button aria-label="Hide/Show" (click)="toggleHidden()">
                {{hideReferences? 'Show References' : 'Hide References'}}
              </aims-common-button>
            </ng-template>

            <aims-common-table-dynamic-row id="discrepancy">
              <ng-template viewMode let-element >
                {{ element.discrepancy.substr(0,300)+'...' }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="pwsRefDesc">
              <ng-template viewMode let-element >
                {{ element.pwsRefDesc ? element.pwsRefDesc.substr(0,300)+'...' : '' }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="altRefDesc">
              <ng-template viewMode let-element >
                {{ element.altRefDesc ? element.altRefDesc.substr(0,300)+'...' : '' }}
              </ng-template>
            </aims-common-table-dynamic-row>

            <aims-common-table-dynamic-row id="pubReferenceId">
              <ng-template viewMode let-element >
                {{ element.pubReferenceId | getText:'publicationId':'pubNum':pubValues | async }}
              </ng-template>

               <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
                  <mat-label>Filter</mat-label>
                  <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                    <mat-option label=""></mat-option>
                    <mat-option *ngFor="let p of pubValues | async" [value]="p.publicationId">
                      {{ p.pubNum }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </aims-common-table-dynamic-row>

        </aims-common-table>

      </div>
    </div>

  </div>
</div>
